const { VUE_APP_NEAR_NFT_CONTRACT_ID, VUE_APP_NEAR_WISHLIST_CONTRACT_ID } = process.env;

function getConfig(network = 'testnet') {
	let config = {
        network,
		testnet: {
            networkId: 'testnet',
            nodeUrl: 'https://rpc.testnet.near.org',
            walletUrl: 'https://wallet.testnet.near.org',
            helperUrl: 'https://helper.testnet.near.org',
            explorerUrl: 'https://explorer.testnet.near.org',
        },
        mainnet: {
            networkId: 'mainnet',
            nodeUrl: 'https://rpc.mainnet.near.org',
            walletUrl: 'https://wallet.near.org',
            helperUrl: 'https://helper.near.org',
            explorerUrl: 'https://explorer.near.org',
        },
		contracts: {
            [VUE_APP_NEAR_NFT_CONTRACT_ID]: {
                viewMethods: [
                    'nft_metadata',
                    'nft_token',
                    'commission_bids',
                    'commission_bids_for_social_id',
                    'commission_bids_total',
                ],
                changeMethods: [
                    'new',
                    'nft_mint',
                    'nft_transfer',
                    'nft_update_price',
                    'nft_purchase',
                    'offer',
                    'commission_bid',
                ],
            },
            [VUE_APP_NEAR_WISHLIST_CONTRACT_ID]: {
                viewMethods: ['metadata', 'wishlist_ids_per_owner', 'wishlist_ids_for_owner', 'wishlist_item_balances', 'gifted_amount', 'paid_gifts', 'givers_per_item', 'giver_ids', 'wishlists', 'average_msrp', 'average_msrps'],
                changeMethods: ['new', 'create_wishlist', 'update_wishlist', 'give_wishlist_items', 'storage_all_count', 'storage_all_data'],
            },
        },
        GAS: '200000000000000'
	};

	return { ...config, ...config[network] };
}

export default getConfig